<div class="modal-header">
  <h4 class="modal-title">{{ "products.register.missing_fender_serial.sku_found_title" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <div class="text-center">
    @if (imageUrl) {
      <img [src]="imageUrl" class="img-thumbnail sku-found-confirm__image" alt="" />
    }
    @if (productTitle) {
      <div class="sku-found-confirm__title">{{ productTitle }}</div>
    }
    @if (sku) {
      <div class="sku-found-confirm__sku">{{ sku }}</div>
    }
    <p class="sku-found-confirm__message">{{ "products.register.missing_fender_serial.sku_found_confirm" | translate }}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.dismiss('Close click')">{{ closeText }}</button>
  @if (submitFn) {
    <button type="button" class="btn btn-primary" (click)="submit()">{{ "general.submit" | translate }}</button>
  }
</div>
